
import React from 'react';

export default () => (
  <div>
    <p>
      I can do JavaScript things like React, jQuery and VanillaJS. I have also built software using
      testing tools like Mocha, Chai, Sinon, Jasmine and Jest.
    </p>

    <p>
      Sadly, I haven't had the time to learn server-side Node-sy stuff like Koa and Express.
      I figured between Rails and Phoenix, I should have most of the bases covered.
      I wouldn't mind learning Koa and/or Express though if required.
      Learning is always fun.
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/stacks/more_info/JavaScript.js